import styled from 'styled-components';
import { spacing } from '@pb/styles';
import { SecondaryCalloutMessage } from '@pb/shared/ui/organisms/secondary-callout-message';
import { FormElement } from '@pb/shared/ui/molecules/form-element';
import { TextArea } from '@pb/shared/ui/atoms/text-area';
import { Paragraph } from '@pb/shared/ui/atoms/paragraph';

export const StyledAddressContainer = styled.div`
    max-width: 100%;
    margin-top: ${spacing(1)};
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.s.min}) {
        margin-bottom: ${spacing(4)};
    }
`;

export const StyledTextArea = styled(TextArea)`
    width: 100%;
`;

export const StyledFormElementContainer = styled.div`
    max-width: 100%;
    width: 100%;

    @media screen and (min-width: ${({ theme }) => theme.breakpoints.s.min}) {
        width: 28rem;
    }
`;

export const StyledFormElement = styled(FormElement)`
    margin: 0;
`;

export const StyledSecondaryCalloutMessage = styled(SecondaryCalloutMessage)`
    margin-top: ${spacing(3)};
`;

export const StyledCalloutLabel = styled(Paragraph)`
    margin-top: ${spacing(1)};
`;

export const StyledOptionalText = styled.label`
    font-weight: ${({ theme }) => theme.font.weight.regular};
    color: ${({ theme }) => theme.color.grey6};
`;

export const StyledButtonContainer = styled.div`
    display: flex;
    justify-content: center;
    max-width: 100%;

    @media screen and (min-width: ${({ theme }) => theme.breakpoints.m.min}) {
        justify-content: right;

        > button {
            width: 13.6rem;
        }
    }
`;
